'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by Administrator on 2016/7/24.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRedux = require('react-redux');

var _payment = require('redux/modules/payment');

var paymentActions = _interopRequireWildcard(_payment);

var _components = require('components');

var _auth = require('redux/modules/auth');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PublicPayment = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var params = _ref.params;

    var promises = [];
    promises.push(dispatch((0, _auth.loadPublicUser)()));
    promises.push(dispatch(paymentActions.load(params.orderNumber, params.activeId, '1')));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    submitted: state.payment.submitted,
    data: state.payment.data,
    paymentData: state.payment.paymentData,
    submitting: state.payment.submitting,
    user: state.auth.publicUser,
    error: state.payment.error
  };
}, paymentActions), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PublicPayment, _Component);

  function PublicPayment() {
    (0, _classCallCheck3.default)(this, PublicPayment);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PublicPayment).call(this));
  }

  (0, _createClass3.default)(PublicPayment, [{
    key: 'onBtnClick',
    value: function onBtnClick(submitData) {
      var _props = this.props;
      var submit = _props.submit;
      var data = _props.data;

      if (data && data.info && data.info[0] && submit) {
        submit((0, _extends3.default)({}, data.info[0], submitData), data.orderNumber, data.activeId, '1');
      }
    }
  }, {
    key: 'onWechatPaymentBtnClick',
    value: function onWechatPaymentBtnClick() {
      var _props2 = this.props;
      var load = _props2.load;
      var data = _props2.data;

      if (data && load) {
        load(data.orderNumber, data.activeId, '1');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props;
      var data = _props3.data;
      var paymentData = _props3.paymentData;
      var user = _props3.user;
      var submitting = _props3.submitting;
      var submitted = _props3.submitted;
      var error = _props3.error;

      var result = _react2.default.createElement(_components.WarningPage, { text: '付款信息有误' });
      if (data && data.info instanceof Array && data.info.length > 0) {
        if (data.info[0].isSuccess === '1') {
          result = _react2.default.createElement(_components.WarningPage, { text: '订单支付成功' });
        } else {
          result = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.PaymentHeader, { orderNumber: data.orderNumber, money: data.info[0].money }),
            _react2.default.createElement(_components.PaymentContent, { info: data.info[0], initialValues: data.info[0],
              onSubmit: this.onBtnClick.bind(this) }),
            error ? _react2.default.createElement(_components.ErrorLabel, { error: error }) : '',
            paymentData ? _react2.default.createElement(_components.WechatPaymentModal, { isOpened: submitted, data: paymentData, user: user,
              onBtnClick: this.onWechatPaymentBtnClick.bind(this) }) : '',
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(_components.LoadModal, { isOpened: submitting })
          );
        }
      }
      return result;
    }
  }]);
  return PublicPayment;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  paymentData: _react.PropTypes.object,
  error: _react.PropTypes.object,
  user: _react.PropTypes.object,
  location: _react.PropTypes.object,
  submitted: _react.PropTypes.bool,
  submitting: _react.PropTypes.bool,
  submit: _react.PropTypes.func,
  load: _react.PropTypes.func,
  dispatch: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = PublicPayment;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PublicPayment/PublicPayment.js
 ** module id = 1531
 ** module chunks = 0
 **/